import { action } from 'typesafe-actions';

import { VoucherTypes } from './types';

// Voucher
export const setToggleVoucher = (payload: { voucher: boolean | null }) =>
  action(VoucherTypes.TOGGLE_VOUCHER, payload);
